import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {LoanApplicationService} from '../service/loan-application.service';
import {LoanApplicationInteractor} from '../interactors/loan-application.interactor';
import {Injectable} from '@angular/core';
import {Location} from '@angular/common';

@Injectable()
export class OnlyBorrowerApplicantsInProgressGuard implements CanActivate {
    constructor(private loanApplicationService: LoanApplicationService,
                private loanApplicationInteractor: LoanApplicationInteractor,
                private router: Router, private location: Location) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        const loanApplication = await this.loanApplicationInteractor.get();

        if (!loanApplication || !loanApplication.id) {
            return true;
        }

        try {
            await this.loanApplicationService.getLatestTransition(loanApplication.id);
            this.location.replaceState(`borrow/application/${loanApplication.id}/status`);
            return this.router.createUrlTree([`borrow/application/${loanApplication.id}/status`]);
        } catch (error) {
            return error.status === 404;
        }
    }
}
